<ion-header>
    <ion-toolbar>
        <ion-title>
            <img style="max-height: 20px;" [src]="logo" alt="">
        </ion-title>
        <ion-buttons slot="end">
            <ion-menu-button color="dark" menu="first" autoHide="false"></ion-menu-button>
        </ion-buttons>
    </ion-toolbar>

    <ion-toolbar  mode="md">
        <ion-segment class="narrow-content">
            <ion-segment-button [routerLink]="['/individual']" (click)="activeTab('individuals')" routerLinkActive="segment-button-checked">
                <ion-icon aria-label="Individuals" name="medal-outline"></ion-icon>
                <ion-label>{{ 'Individuals' | translate }}</ion-label>
            </ion-segment-button>
            <ion-segment-button [routerLink]="['/ties']" (click)="activeTab('team')" routerLinkActive="segment-button-checked">
                <ion-icon aria-label="Team" name="flag-outline"></ion-icon>
                <ion-label>{{ 'Team' | translate }}</ion-label>
            </ion-segment-button>           
            <ion-segment-button [routerLink]="['/featured-events']" (click)="activeTab('featured-events')" routerLinkActive="segment-button-checked">
                <ion-icon aria-label="Featured Events" name="flash-outline"></ion-icon>
                <ion-label>{{ 'Featured Events' | translate }}</ion-label>
            </ion-segment-button>
            
        </ion-segment>
    </ion-toolbar>
</ion-header>

<ion-content>
    <app-ads [adType]="'MATCH'"></app-ads>
    <router-outlet></router-outlet>
@if(hideAddEventButton){
    <ion-fab vertical="bottom" horizontal="end" slot="fixed" name="addMatch">
        <ion-fab-button color="primary" (click)="openAddEventModal()">
            <ion-icon name="add"></ion-icon>
        </ion-fab-button>
    </ion-fab>
}
</ion-content>

@if (location.isCurrentPathEqualTo('/ties')) {
    <ion-footer>
        <ion-toolbar>
            <div class="content-width">
                <ion-button [routerLink]="['/my-teams']" expand="block" fill="clear" shape="round">
                    {{'Manage teams' | translate}}
                </ion-button>
            </div>
            </ion-toolbar>
    </ion-footer>
}

@if (canShowUSNationals()) {
    <ion-footer>
        <ion-toolbar>
            <ion-item id="us-nats" button lines="none" color="none">
                {{'USTA National Championships' | translate}}
                <ion-button slot="end" fill="clear">
                    {{'View' | translate}}
                </ion-button>
            </ion-item>        
        </ion-toolbar>
    </ion-footer>

    <ion-modal 
        [initialBreakpoint]="1" 
        [breakpoints]="[0, 1]" 
        trigger="us-nats">
        <ng-template>
            
        <div class="wrapper">
            <h1>{{'USTA National Championships' | translate}}</h1>
    
            <ion-list>
                <ion-item button [routerLink]="['/tournaments/669ff8bd38dfcc284365c5af/live-score']">
                    {{'US Boys 16s & 18s Nationals (Kalamazoo)' | translate}}
                </ion-item>
                <ion-item button [routerLink]="['/tournaments/66a1bc3838dfcc28436685bb/live-score']" lines="none">
                    {{'US Girls 16s & 18s Nationals (San Diego)' | translate}}  
                </ion-item>
            </ion-list>
        </div>
        </ng-template>
    </ion-modal>
}

<!-- <app-filter-footer *ngIf="location.isCurrentPathEqualTo('/individual')"></app-filter-footer> -->